export default __webpack_public_path__ + "d829f21ff1e290d1998f4e22252a3e24.png";